import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WMSTipoOSService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/wms-tipoos/${this.idconta}`)

    const dataFormatted = response.data.map((tipo) => ({
      ...tipo,
      tipoos: String(tipo.tipoos).trim(),
    }))

    return dataFormatted
  }

  async getById(id) {
    const response = await apinode.get(`/wms-tipoos/${id}/${this.idconta}`)

    return response.data
  }

  async search({ search }) {
    const url = unifyParams(`/wms-tipoos/search/${this.idconta}`, [
      {
        key: 'descricao',
        value: search,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async create(data) {
    await apinode.post(`/wms-tipoos/${this.idconta}`, data)
  }

  async update(id, data) {
    await apinode.put(`/wms-tipoos/${id}/${this.idconta}`, data)
  }

  async delete(id) {
    await apinode.delete(`/wms-tipoos/${id}/${this.idconta}`)
  }
}

export default new WMSTipoOSService()
